import mediator from "@tvg/mediator";
import { PlaceBetGtm } from "./types";

export const removeAllBetsGtmEvent = () => {
  mediator.base.dispatch({ type: "BETSLIP:REMOVE_ALL_SELECTIONS" });
};

export const selectBetAmountGtmEvent = (amountSelected: string) => {
  mediator.base.dispatch({
    type: "BETSLIP:SELECT_BET_AMOUNT",
    payload: {
      amountSelected
    }
  });
};

export const placeBetGtmEvent = ({
  raceNumber,
  trackName,
  betType,
  betAmount
}: PlaceBetGtm) => {
  mediator.base.dispatch({
    type: "BETSLIP:PLACE_BET",
    payload: {
      raceNumber,
      trackName,
      betType,
      betAmount
    }
  });
};
